import { render } from "./ArchivedTask.vue?vue&type=template&id=fb5cfc8c&scoped=true"
import script from "./ArchivedTask.vue?vue&type=script&lang=js"
export * from "./ArchivedTask.vue?vue&type=script&lang=js"

import "./ArchivedTask.vue?vue&type=style&index=0&id=fb5cfc8c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-fb5cfc8c"

export default script